import { Reducer } from 'redux';
import { NotificationActionTypes } from '../actions';
import { NotificationsStoreModel, initialNotificationsStoreState } from '../store.model';

export const notificationsReducer: Reducer<NotificationsStoreModel> = (
  state = initialNotificationsStoreState,
  action
) => {
  switch (action.type) {
    case NotificationActionTypes.NOTIFY_ERROR:
      return { ...state, error: action.payload.message };
    case NotificationActionTypes.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading };
    default:
      return state;
  }
};
